// eslint-disable-next-line import/named
import { createRoute } from "@tanstack/react-router";

import DamPage from "./DamPage";

import PendingComponent from "../../../components/PendingComponent";
import { authLayoutRoute } from "../../auth-layout/route";

export const opellaDamRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "demos/opella/dam",
  component: DamPage,
  pendingComponent: PendingComponent,
});
